var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-alert',{attrs:{"user-name":_vm.user.name,"disabled-module":"billing"}})
}
var staticRenderFns = []

export { render, staticRenderFns }